import { z } from 'zod'

export const registerSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
  firstName: z.string().min(1, 'Ce champ est requis'),
  lastName: z.string().min(1, 'Ce champ est requis'),
  password: z.string().min(1, 'Ce champ est requis'),
})

export type RegisterSchema = z.infer<typeof registerSchema>
